module.exports = __webpack_public_path__ + "img/logo.c7864c4a.png";